export enum PaymentStatusTab {
  Payments = 0,
  BankTransactions = 1,
}

export interface IPaymentStatusState {
    currentTab: PaymentStatusTab;
}